import { QuestionType } from 'civic-champs-shared/question-sets/types'
import {
  DEFAULT_QUESTION_TARGET_BY_TYPE,
  getTargetOptionsForQuestionType,
  serializeQuestionTarget,
  showsQuestionTargetField,
} from 'civic-champs-shared/question-sets/question-target'

export const normalizeTargetForQuestionType = (
  questionType?: QuestionType,
  target?: string | null,
): string | undefined => {
  if (!showsQuestionTargetField(questionType)) {
    return undefined
  }

  const allowedValues = getTargetOptionsForQuestionType(questionType).map(({ value }) => value)
  const current = target ?? ''

  if (allowedValues.includes(current)) {
    return current
  }

  return DEFAULT_QUESTION_TARGET_BY_TYPE[questionType as QuestionType] ?? ''
}

export const resolveQuestionTargetForPayload = (item: {
  questionType?: QuestionType
  target?: string | null
}): string | null => {
  if (!showsQuestionTargetField(item.questionType)) {
    return null
  }
  if (item.target === '') {
    return null
  }
  return serializeQuestionTarget(
    item.target ?? DEFAULT_QUESTION_TARGET_BY_TYPE[item.questionType as QuestionType] ?? null,
  )
}

export const resolveQuestionTargetForForm = (questionType?: QuestionType, target?: string | null) => {
  if (!showsQuestionTargetField(questionType)) {
    return undefined
  }
  if (target === null) {
    return ''
  }
  return target ?? DEFAULT_QUESTION_TARGET_BY_TYPE[questionType as QuestionType] ?? ''
}
